/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { TrackedHardwareEntrypointProps } from './TrackedHardware.entrypoint.types.tsx';

type TrackedHardwareEntryPointComponent = EntryPointComponent<
	{},
	{},
	TrackedHardwareEntrypointProps,
	{}
>;

export const trackedHardwareEntryPoint: EntryPoint<TrackedHardwareEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<TrackedHardwareEntryPointComponent>(
			/* webpackChunkName: "async-itam-settings-tracked-hardware" */ './TrackedHardware.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
